<template>
  <div>
    <list
      row-key="TransportId"
      ref="list"
      unit="业务类型"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"

    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/basedata/basedoc/business/list.json";
import tableParam from "@/data/basedata/basedoc/business/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/businessType").default,
      params: {
        TransportName: "",
        TransportNo: "",
        Status: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
